import React, { useEffect, useState } from 'react'
import Layout from '../../components/layout/Layout'
import { ToastContainer } from 'react-toastify'
import DiscountModal from './modal'
import { deleteDiscount, discountCouponList } from '../../redux/action/discount'
import { DeleteConfirmationModal } from '../../utils/confirmation-modal'

const Discount = () => {
    const [isModalOpen, setModalOpen] = useState(false);
    const [couponList, setCouponList] = useState();
    const [currentItem, setCurrentItem] = useState()

    const [discountId, setDiscountId] = useState('');

    const confirmDelete = () => {
        deleteDiscount(discountId).then((res) => {
            if (res?.success) {
                window.location.href = `/discount`;
                setDiscountId('');
            }
        });
    };

    useEffect(() => {
        discountCouponList().then((res) => {
            setCouponList(res.data);
        })
    }, [])

    const handleEdit = (c) => {
        setCurrentItem(c);
        setModalOpen(true);
    }

    return (
        <Layout title="Discount" page="discount">
            <ToastContainer autoClose={2000} />
            <div className='d-flex justify-content-end me-5'>
                <button className='btn btn-primary'
                    type='button'
                    data-bs-toggle="modal"
                    data-bs-target="#discount"
                    onClick={() => setModalOpen(true)}
                >Create New Discount</button>
            </div>
            <div className='mx-5'>
                <div className="table-responsive table-wrapper">
                    <table
                        className="table table-striped table-row-bordered gy-5 gs-7 border rounded dataTable no-footer"
                    >
                        <thead>
                            <tr className="fw-bolder fs-6 text-gray-800 px-7 arrow-none">
                                <th>SR N.</th>
                                <th>Code</th>
                                <th>Amount</th>
                                <th>Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            {couponList && couponList.map((c, idx) =>

                                <tr key={c._id}>
                                    <td>{idx + 1}</td>
                                    <td>{c.code}</td>
                                    <td>{c.discountAmount}</td>
                                    <td>
                                        <div className='d-flex gap-2'>
                                            <button
                                                type='button'
                                                className="btn btn-info action-hover"
                                                data-bs-toggle="modal"
                                                data-bs-target="#discount"
                                                onClick={() => handleEdit(c)}
                                            >
                                                <svg
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    width="16"
                                                    height="16"
                                                    fill="currentColor"
                                                    className="bi bi-pencil-square"
                                                    viewBox="0 0 16 16"
                                                >
                                                    <path d="M15.502 1.94a.5.5 0 0 1 0 .706L14.459 3.69l-2-2L13.502.646a.5.5 0 0 1 .707 0l1.293 1.293zm-1.75 2.456-2-2L4.939 9.21a.5.5 0 0 0-.121.196l-.805 2.414a.25.25 0 0 0 .316.316l2.414-.805a.5.5 0 0 0 .196-.12l6.813-6.814z"></path>
                                                    <path
                                                        fillRule="evenodd"
                                                        d="M1 13.5A1.5 1.5 0 0 0 2.5 15h11a1.5 1.5 0 0 0 1.5-1.5v-6a.5.5 0 0 0-1 0v6a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5v-11a.5.5 0 0 1 .5-.5H9a.5.5 0 0 0 0-1H2.5A1.5 1.5 0 0 0 1 2.5v11z"
                                                    ></path>
                                                </svg>
                                            </button>
                                            <button
                                                className="btn btn-bg-dark action-hover"
                                                type='button'
                                                data-bs-toggle="modal"
                                                data-bs-target={`#confirmation`}
                                                onClick={() => setDiscountId(c._id)}
                                            >
                                                <svg
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    width="16"
                                                    height="16"
                                                    fill="currentColor"
                                                    className="bi bi-trash-fill"
                                                    viewBox="0 0 16 16"
                                                >
                                                    <path d="M2.5 1a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1H3v9a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2V4h.5a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1H10a1 1 0 0 0-1-1H7a1 1 0 0 0-1 1H2.5zm3 4a.5.5 0 0 1 .5.5v7a.5.5 0 0 1-1 0v-7a.5.5 0 0 1 .5-.5zM8 5a.5.5 0 0 1 .5.5v7a.5.5 0 0 1-1 0v-7A.5.5 0 0 1 8 5zm3 .5v7a.5.5 0 0 1-1 0v-7a.5.5 0 0 1 1 0z" />
                                                </svg>
                                            </button>
                                        </div>
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>
                <DeleteConfirmationModal
                    discountId={discountId}
                    onConfirm={confirmDelete}
                    id="confirmation"
                    title="Confirm Deletion"
                    subtitle="Are you sure you want to delete this item?"
                />
            </div>
            <DiscountModal modalId='discount' isModalOpen={isModalOpen} setModalOpen={setModalOpen} defaultValue={currentItem} />
        </Layout>
    )
}

export default Discount